import React from 'react';
import { motion } from 'framer-motion';
import { FaPhoneAlt, FaEnvelope, FaTelegramPlane } from 'react-icons/fa';

const ContactSection = () => {
  return (
    <section id='contact' className="max-w-6xl mx-auto px-6 py-20 md:py-28 text-blue-900 animate-fade-in">
      <motion.h2
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        className="text-3xl md:text-4xl font-bold mb-8 text-blue-900 text-center"
      >
        Contact Us
      </motion.h2>
      <div className="flex flex-col md:flex-row items-start md:items-center gap-16">

        <div className="flex-1 space-y-4">
          <img
            src="./images/logo.png"
            alt="Company Logo"
            className="w-40 h-40 object-contain transition-transform duration-500 hover:scale-105"
          />
          <h3 className="text-2xl md:text-3xl font-bold text-gray-800 tracking-tight">
            Our Headquarters
          </h3>
          <p className="text-lg leading-relaxed font-medium text-gray-500">
            Ethiopia, Addis Ababa<br />
            Welo Sefer<br />
            China Street
          </p>
        </div>

        {/* Right: Contact Info */}
        <div className="flex-1 space-y-6">
          <h2 className="text-3xl font-extrabold mb-4 text-gray-800 tracking-tight">
            Get in Touch
          </h2>
          <div className="flex flex-col gap-4">
            <a
              href="tel:+251948165959"
              className="flex items-center gap-4 group transition-transform duration-300 hover:translate-x-1"
            >
              <FaPhoneAlt className="text-blue-600 text-2xl group-hover:scale-110 transition-transform" />
              <span className="text-xl font-medium group-hover:underline">+251 (948) 165-959</span>
            </a>

            <a
              href="mailto:talent@insa.gov.et"
              className="flex items-center gap-4 group transition-transform duration-300 hover:translate-x-1"
            >
              <FaEnvelope className="text-blue-600 text-2xl group-hover:scale-110 transition-transform" />
              <span className="text-xl font-medium group-hover:underline">talent@insa.gov.et</span>
            </a>

            <a
              href="https://t.me/cteinsa"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-4 group transition-transform duration-300 hover:translate-x-1"
            >
              <FaTelegramPlane className="text-blue-600 text-2xl group-hover:scale-110 transition-transform" />
              <span className="text-xl font-medium group-hover:underline">@cteinsa</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
